import { motion, useAnimate } from "motion/react";
import { PropsWithChildren, useEffect, useState } from "react";
import { scrollButton } from "./styles.css";

export const ScrollButton = ({ className, direction, onClick }: PropsWithChildren<
  {
    direction: "down" | "up";
    onClick?: () => void;
  } & StyledProps
>) => {

  const [rotateAnimation, setRotateAnimation] = useState({});
  const [scope, animate] = useAnimate();

  const initialPath = 
    direction === "down" ? "M5.5 10.5L16 21L26.5 10.5" : "M26.5 21.5L16 11L5.5 21.5";

  useEffect(() => {
    if (direction === "up") {
      setRotateAnimation({ rotate: 180 });
    };
  }, [direction]); 

  const handleClick = async () => {
    animate(scope.current, { opacity: 1 })
    if (direction === "down") {
      await animate("path", 
        { 
          d: 
            [
              "M5.5 10.5L16 21L26.5 10.5",
              "M5.5 13.6L16 18.1L26.5 13.6",
              "M5.5 10.5L16 21L26.5 10.5"
            ],
        },
        {
          duration: 0.4,
          ease: "easeInOut"
        }
      )
    };
    onClick?.();
  }

  return (
    <motion.button
      ref={scope}
      className={scrollButton}
      onClick={handleClick}
      whileTap={rotateAnimation}
      whileHover={{ opacity: 0.4 }}
    >
      <svg
        className={className}
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <motion.path
          stroke="currentColor"
          strokeWidth="3.93"
          d={initialPath}
        />
      </svg> 
    </motion.button>
  );
};

